export const LINE_CHART_WIDTH = 200;
export const LINE_CHART_HEIGHT = 50;
export const LINE_CHART_HEIGHT_MOB = 70;
export const LINE_CHART_HEIGHT_CARD = 70;
